import { axiosUpdateHeaders } from '@/http'
import { state, mutations, SET_LOADING, RESET_LOADING } from '@/store/modules/common'

export const actions = {
  async getHotel({ commit }, hash) {
    const axios = axiosUpdateHeaders();
    commit(SET_LOADING)

    try {
      const response = await axios.get(`/api/hotel/details/${hash}`);
      return response.data;
    } finally {
      commit(RESET_LOADING);
    }
  }
}

export default {
  namespaced : true,
  state: { ...state },
  mutations: { ...mutations },
  actions
}
